import EChart from "@/components/misc/EChart.vue"
import InfoCenterDrawer from "@/components/shared/InfoCenterDrawer.vue"
import DrawerToggle from "@/components/shared/DrawerToggle.vue"

export default {
  install(app) {
    app.component("EChart", EChart)
    app.component("InfoCenterDrawer", InfoCenterDrawer)
    app.component("DrawerToggle", DrawerToggle)
  }
}
